import React from 'react';
import lokkLogo from 'assets/images/PoweredByLokk.png';

export const Footer = () => {
  return(
    <div className="m-0 p-0 h-100 d-flex justify-content-center align-items-start">
      <img src={lokkLogo} className="m-0 p-0 w-auto" style={{height:20}}/>
    </div>
  );
};